<template>
  <div>
    <div ref="prescriptionPart" class="prescription-page">
      <lk-form
        ref="prescription"
        :label-width="70"
        :rules='validate'
        :model='info'
        :showMessage="!showMessage"
      >
        <div >
          <!-- <lk-row v-if='isShowReplaceBtn'>
            <lk-button
              size='small'
              type='text'
              style="color: #0099ff"
              @click='connectDprescription'
            >关联电子处方</lk-button>
          </lk-row> todo:dch-->
          <lk-row :gutter='16'>
            <lk-col span='11'>
              <lk-form-item label="处方日期:" prop="prescriptionTime">
                <timeStampDatePicker style="width:100%"  placeholder='请选择'
                  v-if='able' v-model="info.prescriptionTime "></timeStampDatePicker>
                <span v-else>{{info.prescriptionTime|formatDate}}</span>
              </lk-form-item>
            </lk-col>
            <lk-col span='11' >
                <lk-form-item label="处方单号:" prop="code">
                <lk-input v-if='able' :maxlength='20' placeholder='请输入'
                  v-model="info.code "></lk-input>
                <span v-else>{{info.code}}</span>
              </lk-form-item>
            </lk-col>
          </lk-row>
          <lk-row :gutter='16'>
            <lk-col span='11'>
              <lk-form-item class="test" label="处方医院:" prop="hospital">
                <prescriptionHospital v-if='able' :maxlength='100'  placeholder='请输入'
                  v-model="info.hospital "></prescriptionHospital>
                <span v-else>{{info.hospital}}</span>
              </lk-form-item>
            </lk-col>
            <lk-col span='11' >
              <lk-form-item label="处方科室:" prop="hospitalDept">
                <lk-input v-if='able' :maxlength='20' placeholder='请输入'
                  v-model="info.hospitalDept "></lk-input>
                <span v-else>{{info.hospitalDept}}</span>
              </lk-form-item>
            </lk-col>
          </lk-row>
          <lk-row :gutter='16'>
              <lk-col span='11'>
              <lk-form-item label="处方医生:" prop="doctor"
                >
                <lk-auto-complete
                  v-if="able"
                  :clearable='true'
                  :maxlength="30"
                  v-model="info.doctor"
                  @on-change="handleSearch1"
                  @on-select='handleSelect'
                  @on-focus='handleFoucus'
                  placeholder="可通过医生姓名搜索"
                  >
                  <div class="test1" v-if='doctorList'>
                    <lk-option
                    v-for="(item,index) in doctorList"
                    :value="item.doctorCode"
                    :key="index"
                    >{{`${item.doctorName}-${item.hospitalName}`}}</lk-option>
                  </div>
                  <div v-else>
                      <div v-if="isEmpty" class="nodata">
                        暂无数据
                      </div>
                    </div>
                </lk-auto-complete>

                <span v-else>{{info.doctor}}</span>
              </lk-form-item>
            </lk-col>
            <lk-col span='11'>
              <lk-form-item label="问诊医生:" prop="inquiryDoctor">
                <lk-input v-if='able' :maxlength='100' placeholder='请输入'
                  v-model="info.inquiryDoctor"></lk-input>
                <span v-else>{{info.inquiryDoctor}}</span>
              </lk-form-item>
            </lk-col>
          </lk-row>
          <lk-row :gutter='16'>
              <lk-col span='11'>
                <lk-form-item label="问诊医院:" prop="inquiryHospital">
                <lk-input v-if='able' :maxlength='100'  placeholder='请输入'
                  v-model="info.inquiryHospital "></lk-input>
                <span v-else>{{info.inquiryHospital}}</span>
              </lk-form-item>
            </lk-col>
            <lk-col span='11'>
              <lk-form-item label="联系人:" prop="prescriptionContact">
                <lk-input v-if='able' :maxlength='100' placeholder='请输入' v-model="info.prescriptionContact">
                </lk-input>
                <span v-else>{{info.prescriptionContact}}</span>
              </lk-form-item>
            </lk-col>
          </lk-row>
          <lk-row :gutter='16' v-if="!isShangBao">
            <lk-col span='11'>
              <lk-form-item label="联系人电话:" prop="prescriptionContactPhone" :label-width='80'>
                <lk-input v-if='able' :maxlength='20' placeholder='请输入' v-model="info.prescriptionContactPhone" >
                </lk-input>
                <span v-else>{{info.prescriptionContactPhone}}</span>
              </lk-form-item>
            </lk-col>
          </lk-row>

          <lk-divider class="divider" style="width: 90%"/>
            <lk-row :gutter='16'>
            <lk-col span='11'>
              <lk-form-item label="患者检索:" >
                <prescriptionSearch  v-if='able' @selected='importPresription' :type="1">
                </prescriptionSearch >
              </lk-form-item>
            </lk-col>
            <lk-col span='11'>
              <lk-form-item label="患者姓名:" prop="patientName">
                <lk-input
                  v-if='able'
                  :maxlength='30'
                  placeholder='请输入'
                  v-model="info.patientName"
                ></lk-input>
                <span v-else>{{info.patientName}}</span>
              </lk-form-item>
            </lk-col>
          </lk-row>
          <lk-row :gutter='16'>
            <lk-col span='11'>
              <lk-form-item label="患者性别:" prop="patientGender">
                <lk-radio-group  v-if='able' v-model="info.patientGender">
                  <lk-radio v-for="(item,index) in genderList" :label="index*1" :key="index">
                    <span>{{item}}</span>
                  </lk-radio>
                </lk-radio-group>
                <span v-else>{{genderList[info.patientGender]}}</span>
              </lk-form-item>
            </lk-col>
            <lk-col span='11'>
              <lk-form-item label="患者年龄:" prop="patientAge">
                <lk-input
                  :maxlength='4'
                  v-if='able'
                  number
                  placeholder='请输入'
                  v-model="info.patientAge "
                  @on-change='handlerAge($event)'
                ></lk-input>
                <span v-else>{{info.patientAge}}</span>
              </lk-form-item>
            </lk-col>
          </lk-row>
          <lk-row :gutter='16'>
            <lk-col span='11'>
              <lk-form-item label="身份证号码:" :label-width='80' prop="patientIdCard" >
                <lk-input :maxlength='18' placeholder='请输入' v-model="info.patientIdCard"  @on-blur='handlerIdCard' v-if='able'></lk-input>
                <span v-else>{{info.patientIdCard}}</span>
              </lk-form-item>
            </lk-col>
            <lk-col span='11'>
              <lk-form-item label="联系方式:" prop="patientPhone">
                <lk-input
                  v-if='able'
                  :maxlength='50'
                  placeholder='请输入'
                  v-model="info.patientPhone"
                ></lk-input>
                <span v-else>{{info.patientPhone}}</span>
              </lk-form-item>
            </lk-col>
          </lk-row>
          <lk-row :gutter='16'>
            <lk-col :span='23'>
              <lk-form-item label='患者地址:'>
                <div class="editRow" v-if='able'>
                  <location style="width:40%" v-model="info.locationArr" @on-change="changeLocation"></location>
                  <lk-input style="width:60%" v-model="info.address"></lk-input>
                </div>
                <div v-else>
                  <span>{{info.locationString}}</span>&nbsp;
                  <span>{{info.address}}</span>
                </div>
              </lk-form-item>
            </lk-col>
          </lk-row>
          <lk-row :gutter='16'>
            <lk-col span='11'>
              <lk-form-item label="处方诊断:" prop="diseaseId"
                >
                <lk-select
                  v-if='able'
                  filterable
                  v-model="info.diseaseId"
                  @on-change='setAdditionalRemark'
                  clearable>
                  <lk-option v-for="(item,index) in diseaseList" :key="index" :value='item.id'>{{item.diseaseName}}</lk-option>
                </lk-select>
                <span v-else>{{info.diseaseName}}</span>
              </lk-form-item>
            </lk-col>
            <lk-col span='11'>
              <lk-form-item label="确诊日期:" prop="diagnosisTime">
                <timeStampDatePicker style="width:100%"  placeholder='请选择'
                  v-if='able' v-model="info.diagnosisTime "></timeStampDatePicker>
                <span v-else>{{info.diagnosisTime|formatDate}}</span>
              </lk-form-item>
            </lk-col>
          </lk-row>
          <lk-row>
            <lk-col span='22'>
              <lk-form-item
                label="诊断补充:"
                prop="diseaseRemark"
                :class="{'ivu-form-item-required':info.diseaseName==='其他'}"
              >
                <lk-input v-if='able' :maxlength='100' placeholder='请输入'
                  v-model="info.diseaseRemark "></lk-input>
                <span v-else>{{info.diseaseRemark}}</span>
              </lk-form-item>
            </lk-col>
          </lk-row>
          <lk-row>
            <lk-col span='8'>
              <lk-form-item label="身高(cm):" prop="patientHeight">
                <NumberInput
                  v-if='able'
                  :maxlength='4'
                  v-model='info.patientHeight'
                  size='default'
                  placeholder="请输入"
                ></NumberInput>
                <!-- <lk-input number v-if='able' :maxlength='4' placeholder='请输入'
                  v-model="info.patientHeight "></lk-input> -->
                <span v-else>{{info.patientHeight}}</span>
              </lk-form-item>
            </lk-col>
            <lk-col span='8'>
              <lk-form-item label="体重(kg):" prop="patientWeight">
                <NumberInput
                  v-if='able'
                  :maxlength='4'
                  v-model='info.patientWeight'
                  size='default'
                  placeholder="请输入"
                ></NumberInput>
                <span v-else>{{info.patientWeight}}</span>
              </lk-form-item>
            </lk-col>
            <lk-col span='8'>
              <lk-form-item label="BMI:" prop="patientBMI">
                <span>{{patientBMI}}</span>
              </lk-form-item>
            </lk-col>
          </lk-row>
          <lk-row :gutter='16'>
            <lk-col span='11'>
              <lk-form-item label="腰围(cm):" prop="patientWaist">
                <NumberInput
                  v-if='able'
                  :maxlength='4'
                  v-model='info.patientWaist'
                  size='default'
                  placeholder="请输入"
                ></NumberInput>
                <span v-else>{{info.patientWaist}}</span>
              </lk-form-item>
            </lk-col>
            <lk-col span='11'>
              <lk-form-item label="医保:" prop="medicalType">
                <lk-select
                  v-if='able'
                  filterable
                  v-model="info.medicalType"
                  clearable>
                  <lk-option v-for="(item,index) in medicalTypeList" :key="index" :value='index*1'>{{item}}</lk-option>
                </lk-select>
                <span v-else>{{medicalTypeList[info.medicalType]}}</span>
              </lk-form-item>
            </lk-col>
          </lk-row>
          <!-- <lk-row>
            <lk-col span='22'>
              <lk-form-item label='患者常住地:' :label-width='84' prop='patientUsualResidence'>
              <location v-model="info.patientUsualResidence"  :disabled='!able'></location>
            </lk-form-item>
            </lk-col>
          </lk-row> -->
          <lk-row :gutter='16'>
            <lk-col span='11'>
              <lk-form-item label="症状:" prop="patientSymptom">
                <lk-input v-if='able' :maxlength='50'  placeholder='请输入'
                  v-model="info.patientSymptom "></lk-input>
                <span v-else>{{info.patientSymptom}}</span>
              </lk-form-item>
            </lk-col>
            <lk-col span='11'>
              <lk-form-item label="体征:" prop="patientSign">
                <lk-input v-if='able' :maxlength='50'  placeholder='请输入'
                  v-model="info.patientSign "></lk-input>
                <span v-else>{{info.patientSign}}</span>
              </lk-form-item>
            </lk-col>
          </lk-row>
          <lk-row :gutter='16'>
            <lk-col span='11'>
              <lk-form-item label='检查结果:'>
                <lk-input v-if='able' :maxlength='50' placeholder='请输入'
                  v-model="info.inspectionResults "></lk-input>
                <span v-else>{{info.inspectionResults}}</span>
              </lk-form-item>
            </lk-col>
            <lk-col span='11'>
              <lk-form-item label='检查图片上传:' :label-width='84'>
                <Uploader
                  v-model.trim='info.inspectionCardUrl'
                  :able="able"
                ></Uploader>
              </lk-form-item>
            </lk-col>
          </lk-row>
        </div>
        <!-- :处方商品  -->
        <PrescriptionGoods
          ref="prescriptionGoods"
          v-model="drugTableData"
          :tableData = tableData
          :usageList='saleUsageList'
          :able='able'
        />
        <!-- 调配人 -->
        <lk-row :gutter='16' style="margin-top: 12px;">
          <lk-col span='11'>
            <lk-form-item label="调配人:" prop="allocater">
              <lk-select :transfer='true' placeholder='请输入' v-if='able'
                @on-change='exchangePharmacistList(info.allocater,"allocaterName")'
                v-model="info.allocater " filterable>
                <lk-option
                  style="z-index:9999;"
                  v-for="item in pharmacistList"
                  :key="item.id"
                  :value='item.id'>{{item.name}}</lk-option>
              </lk-select>
              <span v-else>{{info.allocaterName}}</span>
            </lk-form-item>
          </lk-col>
          <lk-col span='11' >
            <lk-form-item label="复核人:" prop="reviewer">
              <lk-select :transfer='true' v-model="info.reviewer " v-if='able'
                @on-change='exchangePharmacistList(info.reviewer,"reviewerName")'
                placeholder='请输入' filterable>
                <lk-option v-for="item in pharmacistList"
                :key="item.id"
                :value='item.id'>{{item.name}}</lk-option>
              </lk-select>
              <span v-else>{{info.reviewerName}}</span>
            </lk-form-item>
          </lk-col>
        </lk-row>
      </lk-form>
    </div>
    <div class="image-container">
      <prescriptionImage
        :able='able'
        :epid='$route.params.id'
        v-model="info.picUrls"
        :url="info.picUrls"
        :isAbleUpload='able'
        :isNeedChange="isShowReplaceBtn"
        :sourceType='sourceType'
        :showButton="true"
      />
    </div>
  </div>
</template>

<script>
import timeStampDatePicker from '../timeStampDatePicker.vue';
import utils from '../../libs/utils.js';
import prescriptionSearch from './PatientSearch.vue';
import prescriptionHospital from './PrescriptionHospital.vue';
import goods from '../../services/goods';
import system from '../../services/system';
import prescriptionImage from '../sale/Image';
import location from '../location.vue';
import Uploader from '../Uploader.vue';
import PrescriptionGoods from './PrescriptionGoods.vue';

export default {
  name: 'PrescriptionRegistration',
  components: {
    timeStampDatePicker,
    prescriptionSearch,
    Uploader,
    prescriptionHospital,
    prescriptionImage,
    PrescriptionGoods,
    location,
  },
  props: {
    prescription: {
      type: Object,
    },
    diseaseList: {
      type: Array,
      default: () => [],
    },
    drugTableData: {
      type: Array,
      default: () => [],
    },
    usageList: {
      type: Array,
      default: () => [],
    },
    able: {
      type: Boolean,
      default: true,
    },
    isOnline: {
      type: Boolean,
    },
    isShangBao: {
      type: Boolean,
    },
  },
  model: {
    prop: 'prescription',
    event: 'change',
  },
  computed: {
    sourceType() {
      return this.prescription ? this.prescription.sourceType : null;
    },
    patientBMI() {
      const { patientHeight, patientWeight } = this.info;
      if (patientHeight === '' || patientHeight === 0 || patientHeight === null || patientWeight === 0 || patientWeight === null || patientWeight === '') return 0;
      const height = (patientHeight * 1) / 100;
      const BMI = (patientWeight * 1 / (Math.pow(height, 2))).toFixed(1);
      // eslint-disable-next-line no-self-compare
      if (BMI === BMI) {
        return BMI;
      }
      return '';
    },
    showMessage() {
      return this.$route.query.online;
    },
    isShowReplaceBtn() {
      return this.able && this.prescription && this.prescription.sourceType === 8; // 只有编辑页面并且是小程序预约的才显示
    },
  },
  watch: {
    prescription: {
      handler() {
        this.info = this.prescription;
        this.setAdditionalRemark();
      },
      deep: true,
    },
    drugTableData: {
      handler() {
        this.tableData = this.drugTableData.filter(item => item.isRx === 1);
      },
      deep: true,
    },
    usageList: {
      handler() {
        this.saleUsageList = this.usageList;
      },
      deep: true,
    },
  },
  data() {
    return {
      valid: false,
      tableData: [],
      downLoadLoading: false,
      saleUsageList: [], // 处方商品
      validate: {
        prescriptionTime: [{
          required: true,
          message: '请选择处方日期',
          type: 'date',
        }],
        patientPhone: [{
          required: true,
          message: '请输入联系方式',
          trigger: 'change',
        },
        {
          validator: utils.validate.phoneValidator,
          message: '请输入正确联系方式',
          trigger: 'blur',
        },
        ],
        patientName: [{
          required: true,
          message: '请输入患者姓名',
          trigger: 'change',
        }],
        doctor: [{
          required: true,
          message: '请输入处方医生',
          trigger: 'blur',
        }],
        hospital: [{
          required: true,
          message: '请输入处方医院',
          trigger: 'blur',
        }],
        diseaseId: [{
          required: true,
          message: '请选择诊断说明',
          trigger: 'change',
          type: 'number',
        }],
        diagnosisTime: [{
          required: false,
          message: '请选择确诊日期',
          type: 'date',
        }],
        patientAge: [{
          required: true,
          message: '请填写年龄',
          trigger: 'change',
          type: 'number',
        }],
        patientGender: [{
          required: true,
          type: 'number',
          message: '请选择性别',
        }],
        // patientUsualResidence: [{
        //   required: true,
        //   message: '请选择常住地',
        //   trigger: 'change',
        //   type: 'array',
        // }],
        allocater: [{
          required: true,
          message: '请选择调配人',
          type: 'number',
          trigger: 'change',
        }],
        reviewer: [{
          required: true,
          message: '请选择复核人',
          type: 'number',
          trigger: 'change',
        }],
        patientIdCard: [
          {
            validator: utils.validate.IDValidator,
            trigger: 'blur',
          },
        ],
      },
      doctorList: [],
      showGoodsTable: false,
      genderList: {
        1: '男',
        2: '女',
      },
      medicalTypeList: {
        1: '本省市医保',
        2: '外省市医保',
        3: '自费',
      },
      type: '',
      isEmpty: false,
      pharmacistList: [],
      info: {
        patientUsualResidence: [],
        inspectionCardUrl: '',
        patientAge: '',
        patientCode: '',
        patientGender: '',
        patientHeight: '',
        patientIdCard: '',
        patientName: '',
        patientPhone: '',
        patientSign: '',
        patientSymptom: '',
        patientWeight: '',
      },
    };
  },
  methods: {
    changeLocation(val) {
      if (val) {
        this.info.provinceId = val[0];
        this.info.cityId = val[1];
        this.info.countyId = val[2];
        delete this.info.provinceName;
        delete this.info.cityName;
        delete this.info.countyName;
      }
    },
    handlerAge(e) {
      const age = Number(e.target.value.replace(/\D/g, ''));
      this.info.patientAge = age;
    },
    exchangeLocation(locationArr) { // 处理位置数组转换
      if (!locationArr || !locationArr.length) {
        return {};
      }
      const [provinceId, cityId, countyId] = locationArr;
      return {
        provinceId, cityId, countyId,
      };
    },
    validateForm() {
      this.$emit('change', this.info);
      return new Promise((resolve) => {
        this.$refs.prescriptionGoods.validateForm().then((valid1) => {
          this.$refs.prescription.validate((valid) => {
            if (this.showMessage) {
              // 创建订单前置处方没有处方商品也不能创建
              if (this.saleUsageList.length === 0) {
                resolve(false);
              } else {
                resolve(valid1 && valid);
              }
            } else {
              resolve(valid1 && valid);
            }
          });
        });
      });
    },
    handleFoucus() {
      this.isEmpty = false;
    },
    handleSelect(value) {
      this.selectStatus = true;
      this.doctorList.forEach((item) => {
        if (item.doctorCode == value) {
          this.$nextTick(() => {
            this.info.doctor = item.doctorName;
            this.info.prescriptionDoctorId = item.doctorCode;
            this.info.inquiryHospital = item.hospitalName;
            this.info.hospitalDept = item.deptName;
            this.doctorList = [];
            this.$emit('change', this.info);
          });
        }
      });
    },
    handleSearch1: utils.debounce(
      function a(value) {
        if (this.selectStatus) {
          this.selectStatus = false;
          return;
        }
        if (!value) {
          this.isEmpty = false;
          return;
        }
        this.isEmpty = false;
        this.info.prescriptionDoctorId = '';
        this.doctorList = [];
        this.$store.commit('setDisableLoading', true);
        goods.getDoctorList({ param: value }).then((res) => {
          if (res.status === 200) {
            this.doctorList = res.data.data;
            if (!this.doctorList) {
              this.isEmpty = true;
            }
          } else {
            this.$Message.error(res.data.error);
          }
        }).catch((err) => {
          utils.handleError(err);
        });
      }, 2000,
    ),
    setAdditionalRemark() {
      this.info.diseaseName = (this.diseaseList.length && this.info.diseaseId) ? this.diseaseList.find(item => item.id === this.info.diseaseId).diseaseName : '';
      if (this.info.diseaseName === '其他') {
        this.validate.diseaseRemark = [{ required: true, message: '请输入诊断补充说明', trigger: 'change' }];
      } else {
        this.validate.diseaseRemark = [{ required: false }];
        this.diseaseList.length && this.$nextTick(() => {
          this.$refs.prescription.validateField('diseaseRemark', () => {});
        });
      }
    },
    handlerIdCard() {
      let age = utils.idCardChange(this.info.patientIdCard);
      if (age < 0) {
        this.$Message.error('请输入正确的身份证号码');
        age = null;
      }
      this.$set(this.info, 'patientAge', age);
    },
    getpharmacistList() {
      return new Promise((resolve) => {
        system.storeUserList({
          page: 1,
          size: 100,
          statusCodeList: [1],
        }).then((res) => {
          if (res.data.status === 200) {
            const list = [];
            res.data.data.list.forEach((item) => {
              list.push(item.sysUser);
            });
            this.pharmacistList = list;
            resolve();
          } else {
            this.$Message.error(res.data.error);
          }
        }).catch((err) => {
          utils.handleError(err);
        });
      });
    },
    exchangePharmacistList(val, key) {
      console.log(val);
      this.pharmacistList.forEach((item) => {
        if (item.id === val) {
          this.info[key] = item.name;
        }
      });
    },
    importPresription(data) {
      const salePrescription = data.salePrescription;
      const {
        patientAge,
        patientCode,
        patientHeight,
        patientIdCard,
        patientName,
        patientPhone,
        patientSign,
        patientSymptom,
        patientWeight,
      } = salePrescription;
      Object.assign(this.info, {
        patientAge,
        patientCode,
        patientHeight,
        patientIdCard,
        patientName,
        patientPhone,
        patientSign,
        patientSymptom,
        patientWeight,
      });
      this.getPurchaseRecord();
    },
  },

  created() {
  },
  mounted() {
    this.getpharmacistList();
  },
};
</script>

<style lang="less" scoped>
.prescription-page {
  width: 60%;
}
.image-container {
  position: absolute;
  right: 0;
  top: -10px;
  width: 40%;
  height: 400px;
}
.test1 {
  position: relative;
  overflow: auto;
  min-height: 0;
  max-height: 100px;
  /deep/ .ivu-select-item  {
    width:220px;
    overflow:hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
.test {
  /deep/ .ivu-select-item  {
    width:220px;
    overflow:hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
/deep/ .ivu-select-dropdown {
  z-index: 999;
  padding: 0;
}
.divider {
  margin: 12px 0 24px;
}
// /deep/ .ivu-row{
//   margin: 16px 0;
// }
.nodata {
  color: #9a9a9a;
  font-size: 14px;
  padding: 4px 0 4px 4px;
}
.btnCon {
  width: 100%;
  display: flex;
  justify-content: center;
}
.botton-container{
  position: relative;
}
.picDownloadButton{
  position: absolute;
  right: 150px;
  top: 583px;
}
.editRow{
  display: flex;
  justify-content: space-between;
  // margin-bottom: 8px;
  >*:first-child{
    width: 90%;
    >*{

      width: 33%;
    }
  }
}
</style>
